import React from "react";

export const concerts_show_more = {
  "cs-CZ": "zobrazit předchozí koncerty",
  "en-GB": "view previous concerts",
  "fr-FR": "voir les concerts précédents",
  "de-DE": "siehe frühere Konzerte",
};

export const cancel = {
  "cs-CZ": "zrušeno",
  "en-GB": "canceled",
  "fr-FR": "annulé",
  "de-DE": "storniert",
};

export const strikeOut = (canceled) => {
  return canceled === "1" ? { textDecoration: "line-through" } : {};
};

export const caceledFnc = (canceled, lang) => {
  let cancel_messege = <div className="concertCanceled">{cancel[lang]}</div>;
  return canceled === "1" ? cancel_messege : <div></div>;
};



// WEBPACK FOOTER //
// ./src/components/Concerts/concerts.helper.jsx